import { useCallback } from 'react';
import { useAtom } from 'jotai';
import { BasicDialog } from '../../../components/Dialog/BasicDialog';
import { selectedGeneralLedgerActionState } from './generalLedgerState';
import { UploadLedgerForm } from './UploadLedgerForm';

export function UploadLedgerModal() {
  const [selectedAction, setSelectedAction] = useAtom(selectedGeneralLedgerActionState);
  const onClose = useCallback(() => setSelectedAction(null), [setSelectedAction]);
  const open = selectedAction !== null;

  return (
    <BasicDialog open={open} onClose={onClose} title={'Upload General Ledger'} maxWidth='lg' fullWidth>
      {open && <UploadLedgerForm onClose={onClose} />}
    </BasicDialog>
  );
}
